/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../constants.js";
import { decrypt } from "./shares/GlobalFunction.jsx";

function ProsesTest() {
  const navigate = useNavigate();
  let userData = localStorage.getItem("user");
  if (userData) {
    userData = JSON.parse(decrypt(userData));
  } else {
    navigate("/login");
  }

  let id_test = localStorage.getItem("mulai_ujian");
  if (id_test) {
    id_test = JSON.parse(decrypt(id_test));
  } else {
    navigate("/login");
  }

  // eslint-disable-next-line no-unused-vars
  const [post, setPost] = React.useState(null);
  React.useEffect(() => {
    axios.post(API_URL + "/login/info").then((response) => {
      setPost(response.data.res);
    });
  }, []);

  // eslint-disable-next-line no-unused-vars
  const [Subtest, setSubtest] = React.useState(null);
  React.useEffect(() => {
    axios
      .post(API_URL + "/peserta/subtest", {
        id_projek: userData.id_projek,
        id_siswa: userData.id_siswa,
        id_ujian: userData.id_ujian || 0,
        username: userData.nopes,
        kode_akses: userData.kode_akses,
      })
      .then((response) => {
        setSubtest(response.data.data[0]);
      });
  }, []);

  const [DaftarSoal, setDaftarSoal] = React.useState(null);
  React.useEffect(() => {
    axios
      .post(API_URL + "/peserta/daftarsoal", {
        id_projek: userData.id_projek,
        id_siswa: userData.id_siswa,
        id_projek_ujian: id_test,
      })
      .then((response) => {
        setDaftarSoal(response.data.data);
        setStatusJawaban(Array(response.data.data.listSoal.length).fill(""));
      });
  }, []);

  let initialStatus = [].fill("");
  const [statusJawaban, setStatusJawaban] = useState(initialStatus);

  const webcamRef = useRef(null);
  const [capturedImage, setCapturedImage] = useState(null);

  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot();
    setCapturedImage(imageSrc);
  };

  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [noSoal, setNoSoal] = useState(1);

  const handleNextTab = () => {
    let nextIndex = activeTabIndex + 1;
    setActiveTabIndex(nextIndex);
    setNoSoal(nextIndex + 1);
  };

  const handlePreviousTab = () => {
    let nextIndex = activeTabIndex - 1;
    setActiveTabIndex(nextIndex);
    setNoSoal(nextIndex + 1);
  };

  const setTab = (index) => {
    setActiveTabIndex(index);
    setNoSoal(index + 1);
    // alert("jawaban" + index + "=" + statusJawaban[index]);
    // setCheckedById("jawaban" + index, statusJawaban[index]);
  };

  const [isVisible, setIsVisible] = useState(true);

  const toggleVisibility = () => {
    setIsVisible((prev) => !prev);
  };

  const [fontSize, setFontSize] = useState(16); // Initial font size in pixels

  const increaseFontSize = () => {
    setFontSize((prevSize) => prevSize + 2); // Increase font size by 2px
  };

  const decreaseFontSize = () => {
    setFontSize((prevSize) => Math.max(prevSize - 2, 10)); // Decrease font size by 2px but not below 10px
  };

  const handleFinishTest = () => {
    let isAllAnswered = statusJawaban.every((item) => item !== "");
    if (isAllAnswered) {
      handleOpenModal();
    } else {
      setAlertModalOpen(true);
    }
  };

  const [isModalOpen, setModalOpen] = useState(false);
  const [isAlertModalOpen, setAlertModalOpen] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleConfirm = () => {
    setModalOpen(false);
    navigate("/peserta/finish_test");
  };

  const handleCancel = () => {
    setModalOpen(false);
    setAlertModalOpen(false);
  };

  const [selectedValues, setSelectedValues] = useState({
    group1: "option1",
    group2: "optionB",
  });

  const handleRadioChange = (group) => (event) => {
    const value = event.target.value;
    setSelectedValues((prevSelectedValues) => ({
      ...prevSelectedValues,
      [group]: value,
    }));
  };

  return (
    <div className="App" translate="no">
      <div>
        <div className="hidden">
          <h3>Group 1</h3>
          <label>
            <input
              type="radio"
              name="group1"
              value="option1"
              checked={selectedValues["group1"] === "option1"}
              onChange={handleRadioChange("group1")}
            />
            Option 1
          </label>
          <br />
          <label>
            <input
              type="radio"
              name="group1"
              value="option2"
              checked={selectedValues["group1"] === "option2"}
              onChange={handleRadioChange("group1")}
            />
            Option 2
          </label>
        </div>

        <div>
          <h3>Group 2</h3>
          <label>
            <input
              type="radio"
              name="group2"
              value="optionA"
              checked={selectedValues["group2"] === "optionA"}
              onChange={handleRadioChange("group2")}
            />
            Option A
          </label>
          <br />
          <label>
            <input
              type="radio"
              name="group2"
              value="optionB"
              checked={selectedValues["group2"] === "optionB"}
              onChange={handleRadioChange("group2")}
            />
            Option B
          </label>
        </div>
      </div>
    </div>
  );
}

export default ProsesTest;
